export const getBadgesToShow = (badges) => {
  if (!badges || badges.length === 0) {
    return null
  }

  const clonedArray = JSON.parse(JSON.stringify(badges))

  return clonedArray.sort((a, b) => b.priority - a.priority).slice(0, 2)
}
